import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { LabelStyleDirective } from '../../../label/directives/label-style.directive';

@Component({
  selector: 'app-details-view',
  imports: [LabelStyleDirective],
  templateUrl: './details-view.component.html',
  styleUrl: './details-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsViewComponent {
  public readonly label = input.required<string>();
}
